/**
=========================================================
* Material Dashboard 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 PRO React layouts
import Analytics from "layouts/dashboards/analytics";

import CompanyTable from "pages/admin/company";
import NotificationsTable from "pages/admin/notification";
import PATable from "pages/admin/pa";
import Login from "pages/auth/login";
import Password from "pages/auth/password";
import Validate from "pages/auth/validate";
import CooperatedTable from "pages/admin/cooperated";
// import CooperateFormTable from "pages/admin/cooperatedForm";
import UserTable from "pages/admin/user";
import AnaliticTable from "pages/admin/analitic";
import RobotTable from "pages/admin/robot";
import ModelDownload from "pages/admin/model";
import CreateCompany from "pages/admin/crud-company/CreateCompany";
import UpdateCompany from "pages/admin/crud-company/UpdateCompany";
import CreatePA from "pages/admin/crud-PA/CreatePA";
import UpdatePA from "pages/admin/crud-PA/UpdatePA";
import CreateCooperated from "pages/admin/crud-cooperated/CreateCooperated";
import UpdateCooperated from "pages/admin/crud-cooperated/UpdateCooperated";
import CreateUser from "pages/admin/crud-user/CreateUser";
import UpdateUser from "pages/admin/crud-user/UpdateUser";
import FollowUpTable from "pages/admin/followUp";
import Terms from "pages/auth/terms";
import Perfil from "pages/admin/perfil";
import TableCardAprovated from "layouts/dashboards/analytics/components/TableCardAprovated";
import TableCardReprovated from "layouts/dashboards/analytics/components/TableCardReprovated";
import TableCardAwaitingSignature from "layouts/dashboards/analytics/components/TableCardAwaitingSignature";
import TableCardStatusAverageTime from "layouts/dashboards/analytics/components/TableCardStatusAverageTime";
import TableCardAverageApprovalTime from "layouts/dashboards/analytics/components/TableCardAverageApprovalTime";
import CreateFormCooperated from "pages/admin/crud-form-cooperateds/CreateFormCooperated";
import UpdateFormCooperated from "pages/admin/crud-form-cooperateds/UpdateFormCooperated";

const routes = [
  {
    name: "Login",
    key: "login",
    route: "/auth/login",
    component: <Login />,
  },
  {
    name: "Password",
    key: "password",
    route: "/auth/password",
    component: <Password />,
  },
  {
    name: "Terms",
    key: "terms",
    route: "/auth/terms/:uuid",
    component: <Terms />,
  },
  {
    name: "Validate",
    key: "validate",
    route: "/validate/:token",
    component: <Validate />,
  },
  { type: "title", title: "Páginas", key: "title-pages" },
  {
    type: "only",
    name: "Dashboard",
    key: "dashboard",
    route: "/admin/dashboard",
    component: <Analytics />,
  },
  {
    type: "only",
    name: "Companhias",
    key: "companhias",
    route: "/admin/companhias",
    component: <CompanyTable />,
  },
  {
    type: null,
    name: "Notificações",
    key: "notificacoes",
    route: "/admin/notificacoes",
    component: <NotificationsTable />,
  },
  {
    type: null,
    name: "Card Aprovação",
    key: "aprovacoes",
    route: "/admin/aprovados",
    component: <TableCardAprovated />,
  },
  {
    type: null,
    name: "Card Reprovação",
    key: "reprovacoes",
    route: "/admin/reprovados",
    component: <TableCardReprovated />,
  },
  {
    type: null,
    name: "Card Tempo Médio de Aprovação",
    key: "tempo-medio-aprovacao",
    route: "/admin/tempo-medio-aprovacao",
    component: <TableCardAverageApprovalTime />,
  },
  {
    type: null,
    name: "Card Tempo Médio de Status",
    key: "tempo-medio-status",
    route: "/admin/tempo-medio-status",
    component: <TableCardStatusAverageTime />,
  },
  {
    type: null,
    name: "Card Aguardando Assinatura",
    key: "aguardando-assinatura",
    route: "/admin/aguardando-assinatura",
    component: <TableCardAwaitingSignature />,
  },
  {
    type: "only",
    name: "PA's",
    key: "pas",
    route: "/admin/pas",
    component: <PATable />,
  },
  {
    type: "only",
    name: "Novo Cooperado",
    key: "colaboradores",
    route: "/admin/colaboradores",
    component: <CooperatedTable />,
  },
  // {
  //   type: "only",
  //   name: "Formulário Cooperado",
  //   key: "cooperateds",
  //   route: "/admin/cooperateds",
  //   component: <CooperateFormTable />,
  // },
  {
    type: "only",
    name: "Acompanhamento",
    key: "acompanhamento",
    route: "/admin/acompanhamento",
    component: <FollowUpTable />,
  },
  {
    type: "only",
    name: "Usuários",
    key: "usuarios",
    route: "/admin/usuarios",
    component: <UserTable />,
  },
  { type: "divider", key: "divider-0" },
  { type: "title", title: "Docs", key: "title-docs" },
  {
    type: "only",
    name: "Analítico",
    key: "analitico",
    route: "/admin/analitico",
    component: <AnaliticTable />,
  },
  {
    type: "only",
    name: "Robô",
    key: "robo",
    route: "/admin/robo",
    component: <RobotTable />,
  },
  {
    type: "only",
    name: "Downloads",
    key: "model",
    route: "/admin/model",
    component: <ModelDownload />,
  },
  { type: "divider", key: "divider-1" },
  { type: "title", title: "Contato", key: "title-contact" },
  {
    name: "Criar Companhia",
    key: "createCompany",
    route: "/admin/companhias/criar",
    component: <CreateCompany />,
  },
  {
    name: "Atualizar Companhia",
    key: "updateCompany",
    route: "/admin/companhias/atualizar/:uuid",
    component: <UpdateCompany />,
  },
  {
    name: "Criar PA",
    key: "createPA",
    route: "/admin/pas/criar",
    component: <CreatePA />,
  },
  {
    name: "Atualizar PA",
    key: "updatePA",
    route: "/admin/pas/atualizar/:uuid",
    component: <UpdatePA />,
  },
  {
    name: "Criar Colaborador",
    key: "createCooperated",
    route: "/admin/colaboradores/criar",
    component: <CreateCooperated />,
  },
  {
    name: "Atualizar Colaborador",
    key: "updateCooperated",
    route: "/admin/colaboradores/atualizar/:uuid",
    component: <UpdateCooperated />,
  },
  {
    name: "Formulario Criar Colaborador",
    key: "createCooperatedForm",
    route: "/admin/cooperateds/create",
    component: <CreateFormCooperated />,
  },
  {
    name: "Formulario Atualizar Colaborador",
    key: "updateCooperatedForm",
    route: "/admin/cooperateds/update/:uuid",
    component: <UpdateFormCooperated />,
  },
  {
    name: "Criar Usuário",
    key: "createUser",
    route: "/admin/usuarios/criar",
    component: <CreateUser />,
  },
  {
    name: "Atualizar Usuário",
    key: "updateUser",
    route: "/admin/usuarios/atualizar/:uuid",
    component: <UpdateUser />,
  },
  {
    name: "Perfil",
    key: "perfil",
    route: "/admin/perfil",
    component: <Perfil />,
  },
];

export default routes;
